<template>      
    <form @submit.prevent="checkForm" class="mb-4">
        <div class="row">
			<div class="col-12">
				<div class="form-group">
					<label for="payment_date">{{ $t('payment.payment_date') }} *</label>
					<e-datepicker v-model="payment_local.payment_date"></e-datepicker>
				</div>
			</div>
			<div class="col-12" v-if="checkdeposit_configurations.length > 0">
				<div class="form-group">
					<label for="payment_checkdepositconfiguration">{{ $t('payment.payment_checkdepositconfiguration') }}</label>
					<e-select
						id="payment_checkdepositconfiguration"
						v-model="checkdeposit_configuration"
						track-by="checkdepositconfiguration_id"
						label="label"
						:placeholder="getTrad('payment.payment_checkdepositconfiguration_placeholder')"
						:options="checkdeposit_configurations"
						:disabled="payment.check_deposit !== null"
						:show-labels="false"
					/>
					<small v-if="payment.check_deposit !== null" class="form-text text-muted">{{ $t('payment.payment_checkdepositconfiguration_locked') }}</small>
				</div>
			</div>
			<template v-if="payment.method.paymentmethod_code == 'CH'">
				<div class="col-12 col-sm-6">
					<div class="form-group">
						<label for="payment_bankcheck">{{ $t('payment.payment_bankcheck') }}</label>
						<input id="payment_bankcheck" class="form-control" v-model="payment_local.payment_bankcheck" :placeholder="this.getTrad('payment.payment_bankcheck_placeholder')">
					</div>
				</div>
				<div class="col-12 col-sm-6">
					<div class="form-group">
						<label for="payment_bank">{{ $t('payment.payment_bank') }}</label>
						<e-select
							id="payment_bank"
							v-model="payment_local.bank"
							:options="payment_banks"
							track-by="paymentbank_id"
							label="paymentbank_label"
							:allow-empty="false"
						/>
					</div>
				</div>
			</template>
			<div class="col-12">
				<div class="form-group">
					<label for="payment_comment">{{ $t('payment.payment_comment') }}</label>
					<textarea id="payment_comment" class="form-control" v-model="payment.payment_comment" :placeholder="this.getTrad('payment.payment_comment_placeholder')" rows="2"></textarea>
				</div>
			</div>
		</div>
    </form>
</template>

<script type="text/javascript">
	import Payment from "@/mixins/Payment.js"

	export default {
		name: "EditPayment",
		mixins: [Payment],
		props: {
			payment: {
				type: Object,
				default: null
			},
		},
		data () {
			return {
				payment_local: {},
				processing: false,
				payment_banks: this.getConfig('payment_bank'),
				checkdeposit_configurations: [],
				checkdeposit_configuration: null,
				initial_checkdeposit_configuration: null,
				errors: [],
			}
		},
		mounted() {
			this.init_component()
		},
		created () {
		},
		methods: {
			async init_component() {
				this.payment_local = this.payment

				const accountingplan_id = this.payment.accounting_plan.accountingplan_id
				const result = await this.loadPaymentCheckDepositConfigurations([accountingplan_id], [])
				if(result && result.configurations[accountingplan_id]) {
					this.checkdeposit_configurations = result.configurations[accountingplan_id]
					this.checkdeposit_configuration = this.checkdeposit_configurations.find(configuration => configuration.checkdepositconfiguration_id == this.payment.payment_checkdepositconfiguration)
					this.initial_checkdeposit_configuration = this.checkdeposit_configuration
				}

				this.$emit('update:ready', true)
			},
			async checkForm() {

			},

			async editPayment() {
				this.errors = []

				if(!this.processing) {
					this.processing = true
				
					this.$emit('update:processing', true)


					if(!Date.parse(this.payment_local.payment_date)) {
						this.errors.push("Date")
					}

					if(this.errors.length > 0) {
						this.processing = false
						this.$emit('update:processing', false)
						return false
					}

					const params = {
						payment_date: this.payment_local.payment_date,
						payment_bankcheck: this.payment_local.payment_bankcheck,
						payment_bank: (this.payment_local.bank) ? this.payment_local.bank.paymentbank_id : null,
						payment_comment: this.payment_local.payment_comment,
					}

					// Envoyé seulement si l'utilisateur a changé la sélection : la liste ne propose que les comptes
					// actifs, un compte désactivé depuis la saisie n'y figure pas et serait sinon effacé
					if(this.checkdeposit_configuration !== this.initial_checkdeposit_configuration) {
						params.payment_checkdepositconfiguration = this.checkdeposit_configuration ? this.checkdeposit_configuration.checkdepositconfiguration_id : null
					}

					const result = await this.saveEditPayment(this.payment_local.payment_id, params)

					if(result) {
						this.$emit('update:processing', false)
						this.processing = false
						this.successToast()
						if(result.od) {
							this.infoToast('payment.payment_checkdepositconfiguration_od')
						}
						return true
					}
					else {
						this.processing = false
						this.$emit('update:processing', false)
						return false
					}
				}
			},
		}
	}
</script>